import { render, staticRenderFns } from "./Act_report.vue?vue&type=template&id=d6c37c56&scoped=true"
import script from "./Act_report.vue?vue&type=script&lang=js"
export * from "./Act_report.vue?vue&type=script&lang=js"
import style0 from "./Act_report.vue?vue&type=style&index=0&id=d6c37c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c37c56",
  null
  
)

export default component.exports